import { Link } from 'react-router-dom'
import { SERVICES } from '@/data/site'
import { Icon } from '@/components/Icon'
import { SectionHeading } from '@/components/SectionHeading'
import { useReveal } from '@/hooks/useReveal'

export function Services() {
  const revealRef = useReveal<HTMLDivElement>()

  return (
    <section className="section services" ref={revealRef}>
      <div className="container">
        <SectionHeading
          eyebrow="核心服务"
          title="聚焦增值电信业务"
          description="持证经营增值电信业务，依法为企业和机构提供合规、可靠的互联网信息服务与技术支持。"
        />

        <div className="services-grid">
          {SERVICES.map((service, i) => (
            <article key={service.title} className={`service-card reveal delay-${(i % 4) + 1}`}>
              <div className="service-card-icon">
                <Icon name={service.icon as never} size={26} />
              </div>
              <h3 className="service-card-title">{service.title}</h3>
              <p className="service-card-desc">{service.description}</p>
              <div className="service-card-tags">
                {service.tags.map((tag) => (
                  <span key={tag} className="chip">{tag}</span>
                ))}
              </div>
              <Link to="/services" className="service-card-link">
                了解更多
                <Icon name="arrow" size={16} />
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}
